import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { DynamicMapElementPropertiesEditorTemplate, Input } from './DynamicMapElementPropertiesSharedElements';
import { FiCopy } from 'react-icons/fi';
import { undoableMapEditorSelectAreaTriggerWithPrefilledId } from '../../stores/undo/operation/SetPlacementSelectionOp';
export const DynamicMapElementAreaTriggerPropertiesEditor = observer(({
  element,
  mapEditorStore
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(DynamicMapElementPropertiesEditorTemplate, {
    element: element,
    mapEditorStore: mapEditorStore,
    elementTypeKey:
    /*t*/
    "editor.editor_display_type_area_trigger"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, !mapEditorStore.currentMapStore.isCurrentMapPartOfTheModule && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: element.isModuleGate,
    onChange: () => element.setIsModuleGate(!element.isModuleGate)
  }), "\xA0", t("editor.element_is_module_gate_area_trigger")))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.area_trigger_id"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: element.id,
    onChange: ({
      target
    }) => element.setId(target.value)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => undoableMapEditorSelectAreaTriggerWithPrefilledId(element.id, mapEditorStore)
  }, /*#__PURE__*/React.createElement(FiCopy, null), " ", t("editor.extend_area_trigger")))))));
});